const GG_FORM_LINK = 'https://forms.gle/jpSnYTdL8BK9VUEn7'
const PPT_GUIDE =
  // eslint-disable-next-line max-len
  'https://docs.google.com/presentation/d/e/2PACX-1vQEOK_msBgij3m6AVxsxOtTDtf-6CjZi9pMq2o_dk8FJ8r5Nba4yuH2dhwJGOduC1nsnzAX8r0y5epR/pub?start=false&loop=false&delayms=30000'

export { GG_FORM_LINK, PPT_GUIDE }
